<template>
    <validation-observer ref="Appointment">
        <validation-provider name="Randevu Tarihi" :rules="{ required: true}" v-slot="validationContext">
            <b-form-group>
                <b-row> 
                    <b-col sm="4"> <label for="name"> Randevu Tarihi </label> </b-col>
                    <b-col sm="8" class="multiItems">
                        <Datetime id="appointmentDate" v-model="appointmentDate"  :state="getValidationState(validationContext)"></Datetime>
                       
                        <b-form-invalid-feedback style="display: block;">
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-col>
                </b-row>
            
            </b-form-group>
        </validation-provider>
        <validation-provider name="İlgili Teknisyen" :rules="{ required: false}" v-slot="validationContext">
            <b-form-group>
                <b-row> 
                    <b-col sm="4"> <label for="name"> İlgili Teknisyen </label> </b-col>
                    <b-col sm="8" class="multiItems">
                        <Multiselect
                                id="user"
                                v-model="user"
                                :show-labels="false"
                                :options="userList"
                                :state="getValidationState(validationContext)"
                                label="username"
                                track-by="id"
                                :custom-label="customLabel"

                            >
                                <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.firstname }} {{ option.lastname }} </strong>
                                </template>
                            </Multiselect>
                        <b-form-invalid-feedback id="live-feedback">
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-col>
                </b-row>
            </b-form-group>
        </validation-provider>
    </validation-observer>
    
</template>

<script>
    import i18n from '@/plugins/i18n';
    import { Datetime } from 'vue-datetime';
    import Multiselect from 'vue-multiselect'
    import moment from 'moment'

    export default {
        name: "Reserve",
        components:{
            Datetime, Multiselect
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            customLabel (item) {
                return `${item.firstname} ${item.lastname} (${item.username})`
            },
        },
        watch: {
            save: function(data){
                if(data){
                    this.$refs.Appointment.validate().then( async (success) =>{
                            if(success){
                                let data ={
                                    id: this.data.data.id,
                                    appointment_date: moment(this.appointmentDate).format('YYYY-MM-DD HH:mm:ss'),
                                    user_id: this.user.id
                                }
                                await this.$store.dispatch('setTechnicalService', data)
                                if(this.$store.getters.getServiceForm.status == "Success"){
                                    await this.$store.dispatch('serviceFormList')
                                    return true
                                }else{
                                    return false
                                }
                            }
                        }
                    )
                }
                this.saveState(false)
            }
        },
        computed: {
            loading(){
                return this.$store.getters.getDealerLoading
            },
            userList() {
                return this.$store.getters.getUsers
            },
            
        },
        data: function(){
            return{
                hex: false,
                account: "",
                count: 0,
                prefix: "",
                errMsg: "",
                yesNo: [
                    {text: 'Evet', value: true},
                    {text: 'Hayır', value: false}
                ]
            }
        },
        props:{
            data: Object,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
        }

    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Dealer/modals/Appointment.vue